<template>
    <div class="page-shelf-manage">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">同城配送</div>
            <div class="breadcrumb-item">同城批量入庫</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">

                <FormItem>
                    <div class="pg-btn-wrap pg-form-btn">
                    <Select size="small" placeholder="操作人" v-model="form.admin_id" style="width: 95%;">
                        <Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                                :key="item.user_id">{{item.username}} ({{item.realname}})
                        </Option>
                    </Select>
                    </div>
                    <div class="pg-btn-wrap pg-form-btn">
                        <div class="pg-btn style1" @click="handleDownloadFile">下傳Excel模板</div>  
                    </div>
                    <div class="pg-btn-wrap pg-form-btn">
                        <Upload 
                            :before-upload="handleBeforeUpload"
                            accept=".xls, xlsx, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            :format="['xlsx', 'xls']"
                            action="">
                            <div class="pg-btn style2">導入Excel資料</div>
                        </Upload>
                    </div>

                    <Upload 
                        type="drag"
                        :before-upload="handleBeforeUpload"
                        accept=".xls, xlsx, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        :format="['xlsx', 'xls']"
                        action="">
                        <template>
                            <div class="upload-file" style="padding: 50px 100px 50px 100px">
                                <span style="color: #333; font-size: 15px" v-if="uploadFile.file && uploadFile.file.name">{{uploadFile.file.name}}</span>
                                <span style="font-size: 20px" v-else>拖拽Excel到本區域導入</span>
                            </div>
                        </template>
                    </Upload>
                    
                    <div class="pg-btn-wrap" style="text-align: right">
                        <div class="pg-btn" @click="handleClearUpload">取消</div>
                        <div class="pg-btn style2" @click="handleUplodFile">上傳</div>
                    </div> 

                </FormItem>
                <div class="pg-btn-wrap pg-form-btn">
                    <b style="color:red">* 批量入庫需要商家在列表上按下「確認入庫」才生效</b>
                </div>  
            </Form>
        </div>

        <div class="card-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-table-wrap">
                <Table size="small"
                       border
                       no-data-text="暫無數據"
                       :columns="table.column"
                       :data="table.data">
                    <template slot-scope="{ row, index }" slot="action">
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style4" @click="handleModalSignShow(index)">批量詳情</div>
                            <div class="pg-btn style3" @click="handlePrintCode(row.order)">生成PDF</div>
                            <div class="pg-btn style2" @click="handleEdit(index)">確認入庫</div>
                            <div class="pg-btn style1" @click="handleDelete(index)">移出</div>
                        </div>
                    </template>
                </Table>

                <div class="pg-pagger" v-if="totalCount > table.data.length" >
                    <Row>
                        <Col span="12" class="pagger-left">
                            <div class="pagger-total">總共{{totalCount}}條</div>
                        </Col>
                        <Col span="12" class="pagger-right">
                            <!-- v-if="totalCount > curPageSize" -->
                            <div>
                                <div class="pagger-sizer">
                                    <span>每頁</span>
                                    <Select v-model="curPageSize" size="small" placeholder="數量"
                                            @on-change="handlePageSizeChange">
                                        <Option :value="10">10</Option>
                                        <Option :value="20">20</Option>
                                        <Option :value="30">30</Option>
                                        <Option :value="40">40</Option>
                                        <Option :value="50">50</Option>
                                    </Select>
                                </div>

                                <div class="pagger-elevator">
                                    <span>跳轉</span>
                                    <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                           @on-enter="handlePageEnter"/>
                                </div>

                                <Page size="small"
                                      :current="pageIndex"
                                      :page-size="curPageSize"
                                      :total="totalCount"
                                      @on-change="handlePageChange">
                                </Page>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <Modal v-model="isShowModalSign"
           title="批量詳情"
           width="1200"
           :footer-hide="true"
           @on-cancel="handleModalSignClose">
            <div class="modal-cont">
                    <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
                        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                        <div class="loading-text">Loading</div>
                    </Spin>
                   <Table ref="table"
                    size="small"
                    border
                    no-data-text="暫無數據"
                    :columns="table_log.column_log"
                    :data="table_log.data_log">
                        <template slot-scope="{ row, index }" slot="action_two">
                            <div class="pg-btn-wrap pg-form-btn">
                                <Button type="warning" style="margin: 5px;" @click="handleListEdit(row.id)">快遞修改</Button>
                                <Button type="primary" @click="handleListDelete(row.id,row.sack_number)">删除</Button>
                            </div>
                        </template>
                   </Table>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js';
    export default {
        data()
        {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
                isSubmitingLog: false,
                isShowModalSign: false,
                pickAdmin: [],
                //上传
                uploadFile: {
                    file: ''
                },

                shopList: [],
                form: {
                    code: '',    //货架号
                    count: '',  //存放数量
                    type: '',   //货架类型 1大, 2中, 3小
                    store_id: '',   //门店id
                    admin_id: Store.fetch().user_id
                },
                order_delete: '',
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '序號',
                            key: 'id',
                            align: 'center',
							sortable: true,
                            width: 70
                        },
                        {
                            title: '上傳時間',
                            key: 'updated_at',
                            align: 'center',
                            sortable: true
                        },
                        {
                            title: 'Excel表名稱',
                            key: 'name',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '袋號',
                            key: 'order',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '總重量',
                            key: 'weight',
                            align: 'center',
                            sortable: true
                        },
                        {
                            title: '總數量',
                            key: 'number',
                            align: 'center',
                            sortable: true
                        },
                        {
                            title: '總金額',
                            key: 'amount',
                            align: 'center',
                            sortable: true
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            width: 350
                        }
                    ],
                    data: []
                },
                table_log: {
                    column_log: [
                        {
                            title: '快遞序號',
                            align: 'center',
                            key: 'id',
                            minWidth: 160
                        },
                        {
                            title: '快遞單號',
                            align: 'center',
                            key: 'odd_numbers',
                            minWidth: 160
                        },
                        {
                            title: '袋號',
                            align: 'center',
                            key: 'sack_number',
                            minWidth: 160
                        },
                        {
                            title: '重量',
                            align: 'center',
                            key: 'weight',
                            minWidth: 160
                        },
                        {
                            title: '重量金額',
                            align: 'center',
                            key: 'amount',
                            minWidth: 160
                        },
                        {
                            title: '到付運費',
                            align: 'center',
                            key: 'freight_collect',
                            minWidth: 160
                        },
                        {
                            title: '總金額',
                            align: 'center',
                            key: 'totalamount',
                            minWidth: 160
                        },
                        {
                            title: '操作',
                            slot: 'action_two',
                            align: 'center',
                            width: 200
                        }
                    ],
                    data_log: []
                },
                sc_name: '',
                sc_id: '',
                sc_balance: '',
                sc_user_id: '',
                sc_store_id: '',
            };
        },
        created(){
            let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
            let token = localStorage.getItem('jyb_token') || '';
            const state = {
                logInfo,
                token
            };
            if(state.logInfo.userparent != null){
                this.sc_name = state.logInfo.userparent.mark;
                this.sc_id = state.logInfo.userparent.id;
                this.sc_balance = state.logInfo.userparent.balance;
                this.sc_user_id = state.logInfo.user_id;
                this.sc_store_id = state.logInfo.store_id;
            }
            this.getPickAdmin();
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            getPickAdmin()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAdmin,
                    method: 'post'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAdmin = res.data.data;
                    }
                });
            },
            handleModalSignClose(){
                this.isShowModalSign = false;
                this.getList();
            },
            handleModalSignShow(index){
                this.isShowModalSign = true;
                this.isSubmitingLog = true;
                let tableData = this.table.data;
                let floworder = tableData[index].order;

                this.$Rq.requestAuth({
                    url: this.$Api.samecityMultiExcelListDetails,
                    method: 'get',
                    data: {
                        order: floworder
                    }
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    if (res.code == 0)
                    {
                        let tempArr_log = [];
                        let resData = res.data.data;
                        let totalamount = 0;

                        for (let i = 0; i < resData.length; i++)
                        {

                            totalamount = Number(resData[i].amount) + Number(resData[i].freight_collect);

                            tempArr_log.push({
                                id: resData[i].id,
                                odd_numbers: resData[i].odd_numbers,
                                amount: '$'+Number(resData[i].amount),
                                totalamount: '$'+totalamount,
                                arrive: resData[i].arrive,
                                freight_collect: '$'+resData[i].freight_collect,
                                recipient_contacts: resData[i].recipient_contacts,
                                recipient_phone: resData[i].recipient_phone,
                                sack_number: resData[i].sack_number,
                                weight: resData[i].weight
                            });
                        }

                        this.table_log.data_log = tempArr_log;
                    }
                    
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            },
            handleModalSignShowReload(sack){
                this.isShowModalSign = true;
                this.isSubmitingLog = true;
                this.$Rq.requestAuth({
                    url: this.$Api.samecityMultiExcelListDetails,
                    method: 'get',
                    data: {
                        order: sack
                    }
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    if (res.code == 0)
                    {
                        let tempArr_log = [];
                        let resData = res.data.data;
                        let totalamount = 0;

                        for (let i = 0; i < resData.length; i++)
                        {
                            totalamount = Number(resData[i].amount) + Number(resData[i].freight_collect);

                            tempArr_log.push({
                                id: resData[i].id,
                                odd_numbers: resData[i].odd_numbers,
                                amount: '$'+Number(resData[i].amount),
                                totalamount: '$'+totalamount,
                                arrive:resData[i].arrive,
                                freight_collect: '$'+resData[i].freight_collect,
                                recipient_contacts: resData[i].recipient_contacts,
                                recipient_phone: resData[i].recipient_phone,
                                sack_number: resData[i].sack_number,
                                weight: resData[i].weight
                            });
                        }

                        this.table_log.data_log = tempArr_log;
                    }
                    
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            },
            formatDate(datetime)
            {
                if (!datetime) return '';
            
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            handleDownloadFile() {
                window.open(`${this.$Api.samecityDownloadExcel}`, '_blank');
            },
            handleBeforeUpload(file)
            {
                this.uploadFile.file = file;
                return false;
            },
            handleClearUpload(file)
            {
                this.uploadFile.file = '';
                return false;
            },
            handleUplodFile()
            {
                let uploadFile = this.uploadFile;
                this.isSubmiting = true;

                if (uploadFile.file == '')
                {
                    this.$Utils.showTipInfo('請選擇文件');
                    return;
                }

                let formData = new FormData();
                formData.append('file', uploadFile.file);

                this.$Rq.requestAuth({
                    url: this.$Api.samecityimportExcel,
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                })
                .then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0){
                        this.$Utils.showSuccess('導入成功');
                        this.uploadFile = {
                            file: ''
                        };
                        this.pageIndex = 1;
                        this.getList();
                    } 
                    else{
                        this.$Utils.showTipInfo(res.msg);
                        this.uploadFile = {
                            file: ''
                        };
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.isSubmiting = false;
                });
            },
            getList()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.samecityMulteExcelList,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        type: 1,
                        store_id: 0,
                        admin_id: this.form.admin_id,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                id: resData[i].id,
                                order: resData[i].order,
                                amount: '$'+resData[i].amount,
                                updated_at: this.formatDate(resData[i].updated_at),
                                weight: resData[i].weight,
                                number: resData[i].number,
                                name: resData[i].name
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;

                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleListEdit(index)
            {
                this.$router.push({path: '/samecityMultiScaninEdit?id=' + index});
            },
            handleListDelete(index,sack)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定删除快遞單號？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        this.isSubmitingLog = true;
                        let tableData = this.table_log.data;

                        this.$Rq.requestAuth({
                            url: this.$Api.samecityMultiListDelete,
                            method: 'post',
                            data: {
                                order_id: index,
                                sack_number: sack,
                            }
                        }).then((res) =>
                        {
                            this.isSubmitingLog = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);
                                this.handleModalSignShowReload(sack);
                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }
                                this.getList();
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                                this.isSubmitingLog = false;
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });
                    }
                });
            },
            //打印條碼
            handlePrintCode(index)
            {
                let params = {
                    order: index,
                    parent_id: this.sc_id,
                    store_id: this.sc_store_id,
                    user_id: this.sc_user_id,
                };
                this.pdfUrl = this.$Api.samecityorderbatchprint + '?' + this.$Utils.formateObjToParamStr(params);
                window.open(this.pdfUrl);
            },
            handleEdit(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定批量入庫嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;
                        // this.$router.push({path: '/samecityMultiScaninEdit?id=' + tableData[index].id});
                        this.$Rq.requestAuth({
                            url: this.$Api.samecityMultiScanin,
                            method: 'post',
                            data: {
                                order: tableData[index].order
                            }
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);

                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }
                                this.getList();
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });
                    }
                });
            },
            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定删除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.order_delete = tableData[index].order;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.samecityimportExcelDelete,
                            method: 'post',
                            data: {
                                order: this.order_delete,
                            }
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);

                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }
                                this.getList();
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });
                    }
                });
            },
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "samecityMultiScanin.scss";
</style>